import React from "react"
import bluePhoto from "../images/blue_web.jpg"
import { SectionHeader } from "../SectionHeader"
import { STREAMING_LINKS } from "../links"
import "./Music.css"

export const MusicSection = () => (
    <section className="lf-section" id="music">
        <div className="lf-wrap">
            <SectionHeader eyebrow="Listen" title="Music" />

            <div className="lf-music">
                <div className="lf-music__photo" style={{ backgroundImage: `url(${bluePhoto})` }}>
                    <div className="lf-music__corner"></div>
                    <div className="lf-music__caption">LOWFYE50 — NASHVILLE, TN</div>
                </div>

                <div>
                    <p className="lf-music__intro">Stream Lowfye50 wherever you listen.</p>
                    <ul className="lf-platforms">
                        {STREAMING_LINKS.map((link, i) => (
                            <li key={link.name}>
                                <a target="_blank" rel="noreferrer" href={link.href}>
                                    <span className="lf-platforms__n">0{i + 1}</span>
                                    <span className="lf-platforms__name"><i className={link.icon}></i>{link.name}</span>
                                    <span className="lf-platforms__go"><i className="fas fa-arrow-right"></i></span>
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    </section>
)

export const Music = () => <MusicSection />
